import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Box from '../Box';

const StyledTable = styled(Box)`
  width: 100%;
  border-collapse: separate;
  border-radius: 4px;
  border: 1px solid ${themeGet('colors.grayscale.300')};
  border-bottom: 0;
`;
const Table = (props) => <StyledTable display="table" {...props} />;

const TBody = (props) => <Box display="table-row-group" {...props} />;

const THead = (props) => <Box display="table-row-group" {...props} />;

const Tr = (props) => <Box display="table-row" mb={['16px', 0]} {...props} />;

const StyledTh = styled(Box)`
  border-bottom: 1px solid ${themeGet('colors.grayscale.300')};
  font-weight: 600;
  vertical-align: middle;
`;
const Th = (props) => (
  <StyledTh display="table-cell" p={['15px 10px', '15px 15px']} {...props} />
);

const StyledTd = styled(Box)`
  border-bottom: 1px solid ${themeGet('colors.grayscale.300')};
  vertical-align: middle;
`;
const Td = (props) => (
  <StyledTd display="table-cell" p={['5px 10px', '5px 15px']} {...props} />
);

export { Table, TBody, THead, Tr, Th, Td };
